import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';

// Thunk to fetch top topcategories
export const getProductThunk = createAsyncThunk(
  'product/product',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.getProduct(data);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data
          ? error.response.data.message
          : 'Failed to fetch top categories'
      );
    }
  }
);



// Thunk to fetch top topcategories
export const getProductDetailsThunk = createAsyncThunk(
  'product/getProductDetails',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.getProductDetails(id);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data
          ? error.response.data.message
          : 'Failed to fetch top categories'
      );
    }
  }
);

export const getSimilarProductThunk = createAsyncThunk(
  'product/getSimilarProductThunk',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.getSimilarProducts(id);

      return response.data;
    } catch (error) {
      console.log(error);

    }
  }
);


export const getfilterproductcountThunk = createAsyncThunk(
  'product/getfilterproductcountThunk',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.getfilterproductcount(id);

      return response.data?.data;
    } catch (error) {
      console.log(error);

    }
  }
);

export const getfilterproductThunk = createAsyncThunk(
  'product/getfilterproductThunk',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.getfilterproduct(id);

      return response.data;
    } catch (error) {
      console.log(error);

    }
  }
);


export const getProductcountThunk = createAsyncThunk(
  'excess/getProductcountThunk',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.getProductcount(data);
      console.log(response.data);
      
      return response.data?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

// Slice for categories
const getSimilarProductSlice = createSlice({
  name: 'products',
  initialState: {
    products: [],
    loading: false,
    error: null,
    page: 1,
    productDetails: {},
    compareProduct: [],
    similarProducts: [],
    similarpage: 1,
    productcount: null,
    filterloading: false,
    filteredproducts: [],
    filterPage: 1,
    productCount: {
      data: {},
      loading: false
    },
    filter: [],
    appliedFilters: [],
    similarAppliedFilters:[],
    similarfilters:[],
    search: ""
  },
  reducers: {
    setProductPage: (state, action) => {
      state.page = action.payload
    },
    setFilterPage: (state, action) => {
      state.filterPage = action.payload
    },
    setSimilarPage: (state, action) => {
      state.similarpage = action.payload
    },
    setCompareProduct: (state, action) => {
      state.compareProduct = action.payload
    },
    deleteCompareproduct: (state, action) => {
      state.compareProduct = state.compareProduct.filter((product) => product?._id != action.payload)
    },
    setProductAppliedFilters: (state, action) => {
      state.appliedFilters = action.payload
    },
    setProductSearch: (state, action) => {
      state.search = action.payload
    },
    setProductFilter: (state, action) => {
      state.filter = action.payload
    },
    setSimilarProductFilter: (state, action) => {
      state.similarfilters = action.payload
    },
    setSimilarAppliedProductFilter: (state, action) => {
      state.similarAppliedFilters = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProductThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(getProductThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //getDetails
      .addCase(getProductDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.productDetails = action.payload;
      })
      .addCase(getProductDetailsThunk.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getSimilarProductThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSimilarProductThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.similarProducts = action.payload;
      })
      .addCase(getSimilarProductThunk.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getfilterproductThunk.pending, (state) => {
        state.filterloading = true;
      })
      .addCase(getfilterproductThunk.fulfilled, (state, action) => {
        state.filterloading = false;
        state.filteredproducts = action.payload;
      })
      .addCase(getfilterproductThunk.rejected, (state, action) => {
        state.filterloading = false;
      })

      .addCase(getfilterproductcountThunk.pending, (state) => {
        state.filterloading = true;
      })
      .addCase(getfilterproductcountThunk.fulfilled, (state, action) => {
        state.filterloading = false;
        state.productcount = action.payload;
      })
      .addCase(getfilterproductcountThunk.rejected, (state, action) => {
        state.filterloading = false;
      })


      .addCase(getProductcountThunk.pending, (state) => {
        state.productCount.loading = true;
      })
      .addCase(getProductcountThunk.fulfilled, (state, action) => {
        state.productCount.loading = false;
        state.productCount.data = action.payload;
      })
      .addCase(getProductcountThunk.rejected, (state, action) => {
        state.productCount.loading = false;
      });
  },
});

export const { setProductPage, setCompareProduct, deleteCompareproduct, setSimilarPage, setFilterPage ,setProductFilter,setProductAppliedFilters,setProductSearch,setSimilarAppliedProductFilter ,setSimilarProductFilter} = getSimilarProductSlice.actions
export default getSimilarProductSlice.reducer;

